import React from "react";
import useSearchState from "../../useSearchState";
import { SearchResultsHeaderRow } from "./header/SearchResultsHeaderRow";
import { ResultsScrollbar } from "./partials/ResultsScrollbar";
import { SearchResultsFooterRow } from "./partials/SearchResultsFooterRow";
import { SearchResultsRow } from "./partials/SearchResultsRow";
import { SearchResultsSubheaderRow } from "./partials/SearchResultsSubheaderRow";
import usePrintSearchResult from "./usePrintSearchResult";
import { resultRowType, resultsDisplayType } from "../../../common/types/search/results";
import Immutable from "immutable";

export function StandardSearchResultsTable({
	resultRenderConfig,
	footnotes,
	forPrint = false,
	paging,
}: resultsDisplayType) {
	const { rows, total, columnsVisible } = useSearchState([""]);
	const { rowsForPrint } = usePrintSearchResult();

	const items = forPrint ? rowsForPrint : rows;

	const getRowClasses = (item: Immutable.Map<string, unknown>) =>
		item.get("default_status") === "0" ? "inactive" : "";

	if (!items || items.isEmpty()) {
		return null;
	}

	const {
		columnHeaderGenerator,
		columnCellGenerator,
		columnFooterGenerator,
		columnSubheaderGenerator,
	} = resultRenderConfig;
	footnotes && footnotes.clearFootnotes();

	return (
		<ResultsScrollbar forPrint={forPrint}>
			<table>
				<SearchResultsHeaderRow
					columnsVisible={columnsVisible}
					columnHeaderGenerator={columnHeaderGenerator}
				/>
				<tbody>
					<SearchResultsSubheaderRow
						total={total}
						columnsVisible={columnsVisible}
						columnSubheaderGenerator={columnSubheaderGenerator}
					/>
					{items.map((item: resultRowType, index: number) => (
						<SearchResultsRow
							key={index}
							additionalClasses={getRowClasses(item)}
							item={item}
							columnsVisible={columnsVisible}
							footnotes={footnotes}
							columnCellGenerator={columnCellGenerator}
						/>
					))}
				</tbody>
				<SearchResultsFooterRow
					columnsVisible={columnsVisible}
					paging={paging}
					columnFooterGenerator={columnFooterGenerator}
				/>
			</table>
		</ResultsScrollbar>
	);
}
